import { configureStore } from "@reduxjs/toolkit";
import talentsReducer from "../features/talents/talentsSlice";
import departmentReducer from "../features/departmentsSlice";
import positionsReducer from "../features/positionsSlice";
import authReducer from "../features/authSlice";
import adminReducer from "../features/administrationSlice";
import companiesReducer from "../features/companiesSlice";

const store = configureStore({
  reducer: {
    talents: talentsReducer,
    departments: departmentReducer,
    positions: positionsReducer,
    auth: authReducer,
    admin: adminReducer,
    companies: companiesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
